export default __webpack_public_path__ + "static/media/info.8c79d602.svg";